import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const Card = styled.div`
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  color: #8747d4;
  text-align: center;
  margin-bottom: 20px;
  font-family: "Quicksand", sans-serif;
`;

const ScoreCircle = styled.div`
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8747d4, #a678de);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
`;

const ScoreNumber = styled.div`
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 1;
  font-family: "Quicksand", sans-serif;
`;

const ScoreLabel = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  opacity: 0.9;
  font-family: "Quicksand", sans-serif;
`;

const TimeStat = styled.div`
  font-size: 1.2rem;
  color: #555;
  margin: 10px 0;
  font-weight: 600;
  font-family: "Quicksand", sans-serif;
`;

const Subtitle = styled.p`
  color: #888;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-top: 20px;
  font-family: "Quicksand", sans-serif;
`;

const EndDateText = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: #dd6260;
  margin-top: 14px;
  font-family: "Quicksand", sans-serif;
`;

const ParticipantCountText = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  color: #888;
  margin-top: 12px;
  font-family: "Quicksand", sans-serif;
`;

const ActionButton = styled(motion.button)`
  background: #8747d4;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 16px 40px;
  font-size: 1.1rem;
  font-weight: 700;
  font-family: "Quicksand", sans-serif;
  cursor: pointer;
  box-shadow: 0 4px 0 #6535a3;
  display: block;
  margin: 30px auto 0;
`;

function formatTimeDisplay(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) return `${seconds} seconds`;
  if (seconds === 0) return `${minutes} mins`;
  return `${minutes} mins and ${seconds} seconds`;
}

function ChallengeCompleteCard({
  score,
  totalQuestions,
  timeTaken,
  participantCount,
  endDate,
  onBackToHome,
}) {
  return (
    <Card>
      <Title>Challenge Complete!</Title>
      <ScoreCircle>
        <ScoreNumber>
          {score}/{totalQuestions}
        </ScoreNumber>
        <ScoreLabel>Score</ScoreLabel>
      </ScoreCircle>
      <TimeStat>Time: {formatTimeDisplay(timeTaken)}</TimeStat>
      {participantCount != null && (
        <ParticipantCountText>
          {participantCount} participant{participantCount !== 1 ? "s" : ""} so
          far
        </ParticipantCountText>
      )}
      
      <Subtitle>
        The winner will be revealed when the competition ends. Thanks for taking
        the challenge!
      </Subtitle>
      {endDate && (
        <EndDateText>
          Challenge ends{" "}
          {new Date(endDate).toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          })}
        </EndDateText>
      )}
      <ActionButton whileTap={{ scale: 0.95 }} onClick={onBackToHome}>
        Back to Home
      </ActionButton>
    </Card>
  );
}

export default ChallengeCompleteCard;
